import { Grid, styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const AgentInfoItemWrapper = styled(Grid)(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",

  width: "100%",

  "&:hover": {
    "& > div": {
      opacity: "1",
    },
  },

  transition: "opacity 0.5s ease-in-out",
}));

const useStyles = makeStyles(() => ({
  modalBody: {
    maxWidth: "394px !important",
    width: "100% !important",
  },
}));

export default useStyles;
